import last from 'lodash/last';

export const CLOUD_NAME = 'superpedestrian';
export const PROFILE_UPLOAD_PRESET = 'wrangler_profile_photos';
export const PROFILE_BUCKET_NAME = 'wrangler_profile_photos';
export const LOCATION_UPLOAD_PRESET = 'wrangler_location_photos';
export const LOCATION_BUCKET_NAME = 'wrangler_location_photos';
const MAX_FILE_SIZE = 3000000;
const DEFAULT_THEME = 'minimal';
const { cloudinary } = window;

export function uploadUserImage(event) {
  event.preventDefault();
  return new Promise((fulfilled, rejected) => {
    cloudinary.openUploadWidget({
      cloud_name: CLOUD_NAME,
      max_file_size: MAX_FILE_SIZE,
      theme: DEFAULT_THEME,
      uploadPreset: PROFILE_UPLOAD_PRESET,
      sources: ['camera', 'local'],
      multiple: false,
    }, (error, result) => {
      if (error) {
        rejected();
      }
      if (result.event === 'success' && result.info) {
        fulfilled(result.info);
      }
    });
  });
}

export function uploadLocationImage(event) {
  event.preventDefault();
  return new Promise((fulfilled, rejected) => {
    const images = [];
    let imageCount = 0;
    cloudinary.openUploadWidget({
      cloud_name: CLOUD_NAME,
      max_file_size: MAX_FILE_SIZE,
      theme: DEFAULT_THEME,
      upload_preset: LOCATION_UPLOAD_PRESET,
      client_allowed_formats: ['png', 'jpeg'],
      multiple: true,
      sources: ['local'],
    }, (error, result) => {
      if (error) {
        rejected();
      }
      if (result.event === 'upload-added') {
        // upload-added seems to fire right away for each upload
        // without this, returns after the first success
        imageCount++;
      }
      if (result.event === 'success' && result.info) {
        images.push(result.info);
      }
      if (images && imageCount && images.length === imageCount) {
        fulfilled(images);
      }
    });
  });
}

export function convertImageUrlToPublicId(url) {
  return last(url.split('/')).slice(0, -4);
}
